import type { JSX } from 'react'
import type { AIProposal } from '#src/components/rich-text-editor/AIProposalsExtension.ts'
import { SuggestionSourceExcerpt } from '#src/components/rich-text-editor/SuggestionSourceExcerpt.tsx'
import { RenderSafeContext } from '#src/contexts/RenderSafeContext.tsx'

export interface ChoiceSourceWidgetProps {
  proposal: AIProposal
}

/* What the widget shell hosts for a choice pick that cited a source: the same
 * excerpt a text suggestion draws under its card, with no card, because the
 * pick itself is only the tint on one option of a field in the text. Without
 * this the source is on screen only while the pointer is over that option. */
export function ChoiceSourceWidget({
  proposal,
}: ChoiceSourceWidgetProps): JSX.Element {
  return (
    <RenderSafeContext.Provider value={true}>
      <SuggestionSourceExcerpt
        citation={proposal.citation}
        sourceProvenance={proposal.sourceProvenance}
      />
    </RenderSafeContext.Provider>
  )
}
